import React from 'react';
import { useSelector } from 'react-redux';
import { selectPropertyWalkThroughFormStep } from 'src/store/selectors/propertyWalkThroughForm';
import ConfigurePropertyWalkThrough from './ConfigurePropertyWalkThrough';
import ConfigureSubArea from './ConfigureSubArea';
import ReviewWalkThrough from './ReviewWalkThrough';
import ReviewDeveloperWalkthrough from './ReviewDeveloperWalkthrough';
import { MobileAppCallToAction } from '../MobileAppCallToAction/MobileAppCallToAction';

const PropertyWalkThroughFormSteps = (props: any) => {
  const propertyWalkThroughFormStep: any = useSelector((state: any) =>
    selectPropertyWalkThroughFormStep(state)
  );

  // TODO: phase 2 - replace this numeric-step switch with intent-named component
  // routing (e.g. <ConfigureStep />, <InProgressStep />, <ReviewStep />,
  // <SimplifiedReviewStep />). Cases 0/1/3/5 are the only valid steps; any
  // other dispatched step (e.g. step 4) silently falls through to
  // MobileAppCallToAction — root-cause hazard surfaced during WEB-1350.
  // Asana: TBD (sibling ticket to the propertyWalkThroughForm slice retirement)
  switch (propertyWalkThroughFormStep) {
    case 0:
      return <ConfigurePropertyWalkThrough {...props} />;
    case 1:
      return <ConfigureSubArea {...props} />;
    case 3:
      return <ReviewWalkThrough {...props} />;
    case 5:
      return <ReviewDeveloperWalkthrough {...props} />;
    default:
      return <MobileAppCallToAction />;
  }
};

export default PropertyWalkThroughFormSteps;